import axios from '../axiosInstance';

export default class {
  constructor(options) {
    this.options = options;
    this.URL = `${this.options.baseUrl}/rauth/profiles`;
  }

  async save(profile) {
    try {
      this.URL = `${this.options.baseUrl}/rauth/profiles`;
      const res = await axios.put(`${this.URL}/current`, profile);

      return res.data;
    } catch (e) {
      throw new Error('profileService->save: ' + e.message);
    }
  }

  /**
   * Gets a users profile
   * @returns {Object} A user profile
   */
  async get(id = null) {
    try {
      this.URL = `${this.options.baseUrl}/rauth/profiles`;
      const res = await axios.get(`${this.URL}/${id ? id : 'current'}`);

      return res.data;
    } catch (e) {
      return new Error('profileService->getProfile: ' + e.message);
    }
  }

  /**
   * Gets a users ID
   * @returns {Number} User ID
   */
  async getId() {
    try {
      this.URL = `${this.options.baseUrl}/rauth/profiles`;
      const res = await axios.get(`${this.URL}/current`);

      return res.data['django_ref_id'];
    } catch (e) {
      return new Error('profileService->getId: ' + e.message);
    }
  }
}
